import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Emergent-managed Google OAuth session hook.
// login() REMINDER: DO NOT HARDCODE THE AUTH URL PARAMS OR ADD FALLBACK REDIRECTS — IT BREAKS THE AUTH.
export const useAuth = () => {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    const token = localStorage.getItem("session_token");
    if (!token) {
      setUser(null);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("session_token");
        setUser(null);
      });
  }, []);

  const login = () => {
    sessionStorage.setItem("auth_return", window.location.pathname);
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    const token = localStorage.getItem("session_token");
    try {
      await axios.post(`${API}/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } });
    } catch {}
    localStorage.removeItem("session_token");
    setUser(null);
    toast.success("Logged out.");
  };

  return { user, login, logout, token: localStorage.getItem("session_token") };
};
